module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('div', {
    staticClass: "arrow__item"
  }, [_c('div', {
    staticClass: "arrow__zone arrow__zone_back",
    on: {
      "click": function($event) {
        return _vm.changeImage('back')
      }
    }
  }, [_c('CardSliderArrowSvg', {
    attrs: {
      "color": _vm.color
    }
  })], 1)]), _c('div', {
    staticClass: "arrow__item arrow__item_right"
  }, [_c('div', {
    staticClass: "arrow__zone arrow__zone_forward",
    on: {
      "click": function($event) {
        return _vm.changeImage('forward')
      }
    }
  }, [_c('CardSliderArrowSvg', {
    attrs: {
      "color": _vm.color,
      "isLeftArrow": false
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67050119","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/slider/images/components/CardSliderArrow.vue
// module id = 01ef2338312b1a50cca5
// module chunks = 0